var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestOfferings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15454"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 75",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#FD5901"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 78",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 79",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9823 14L25.3762 20.8748L32.9646 21.9771L27.4764 27.3319L28.7701 34.8913L21.9823 31.3234L15.1945 34.8913L16.4941 27.3319L11 21.9771L18.5884 20.8748L21.9823 14Z",
    stroke: "white",
    strokeWidth: 0.580154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.9823 36.6257L25.3762 29.7509L32.9646 28.6486L27.4764 23.2938L28.7701 15.7344L21.9823 19.3023L15.1945 15.7344L16.4941 23.2938L11 28.6486L18.5884 29.7509L21.9823 36.6257Z",
    stroke: "white",
    strokeWidth: 0.580154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.6096 24.2168H24.3553",
    stroke: "white",
    strokeWidth: 0.580154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.6096 26.874H24.3553",
    stroke: "white",
    strokeWidth: 0.580154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestOfferings);
export default __webpack_public_path__ + "static/media/Best Offerings.c45963458c3881a108b3cfb6c9a3bd64.svg";
export { ForwardRef as ReactComponent };